import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';
import ContenidoAvisoPrivacidad from '../components/sections/AvisoPrivacidad/ContenidoAvisoPrivacidad';
import TituloAvisoPrivacidad from '../components/sections/AvisoPrivacidad/TituloAvisoPrivacidad';

const AvisoDePrivacidad = () => (
  <>
    <SeoMetadata
      title="Aviso de Privacidad | Decototal"
      description="Consulta el aviso de privacidad de Decototal y conoce cómo se protege y utiliza la información personal proporcionada en este sitio."
      keywords="aviso de privacidad Decototal, privacidad, datos personales"
      path="/aviso-de-privacidad"
      image="/assets/img/contacto/banner-contacto.jpg"
    />
    <Header />
    <TituloAvisoPrivacidad />
    <ContenidoAvisoPrivacidad />
    <Footer />
  </>
);

export default AvisoDePrivacidad;
